/**
 * Sanitize user-visible text by removing UUIDs, Python "None" literals,
 * and cleaning up leftover whitespace/prepositions.
 */
const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

export function stripUuids(text: string): string {
    let result = text
        .replace(UUID_PATTERN, "")            // remove UUIDs
        .replace(/\bNone\b/g, "")             // remove Python "None" literals
        .replace(/\s{2,}/g, " ")              // collapse multiple spaces
        .replace(/\s+([.,;:!?])/g, "$1")      // remove space before punctuation
        .replace(/\s*(for|per|di|da)\s*$/i, "") // remove trailing prepositions
        .trim();
    // Remove trailing "rilevata", "reported" etc. left without object
    result = result.replace(/\s+(rilevata|risolta|reported)\s*$/i, "").trim();
    return result;
}
